import React, { FC, ReactNode } from "react";
import styles from "./SectionDivider.module.scss";
import clsx from "clsx";
import {
  BackgroundColor,
  cssVariableForColor
} from "../Backgrounds/background";
interface SectionDividerProps {
  children: ReactNode;
  className?: string;
  backgroundColorTop?: BackgroundColor;
  backgroundColorBottom?: BackgroundColor;
  spacingTop?: null | "regular" | "compact" | "condensed";
  spacingBottom?: null | "regular" | "compact" | "condensed";
  dataContentName?: string;
}

export const SectionDivider: FC<
  React.PropsWithChildren<SectionDividerProps>
> = ({
  className,
  backgroundColorTop = "transparent",
  backgroundColorBottom = "transparent",
  spacingTop = null,
  spacingBottom = null,
  children,
  dataContentName = null
}) => {
  const style = {
    "--background-top": cssVariableForColor(backgroundColorTop),
    "--background-bottom": cssVariableForColor(backgroundColorBottom)
  } as React.CSSProperties;

  return (
    <div
      style={style}
      className={clsx(className, {
        [styles.sectionDivider]: true,
        [styles.spacingTopRegular]: spacingTop == "regular",
        [styles.spacingBottomRegular]: spacingBottom == "regular",
        [styles.spacingTopCompact]: spacingTop == "compact",
        [styles.spacingBottomCompact]: spacingBottom == "compact",
        [styles.spacingTopCondensed]: spacingTop == "condensed",
        [styles.spacingBottomCondensed]: spacingBottom == "condensed"
      })}
      data-content-name={dataContentName}
    >
      {children}
    </div>
  );
};
